import { createRoot } from "react-dom/client"
import "./index.css"
import App from "./App.tsx"
import * as Sentry from "@sentry/react"
import { BrowserRouter } from "react-router-dom"
import Auth0ProviderWithNavigate from "./auth/Auth0ProviderWithNavigate"

Sentry.init({
  dsn: "https://aee845b54dcc89f6c100b8931908e89d@o560939.ingest.us.sentry.io/4510272038764544",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <Auth0ProviderWithNavigate>
      <App />
    </Auth0ProviderWithNavigate>
  </BrowserRouter>,
)
